export default __webpack_public_path__ + "static/media/sip.1ab05d44.svg";